/* eslint-disable spaced-comment,func-names,object-shorthand */
import React from 'react';
import request from 'superagent';
import Highcharts from 'highcharts';
import Highstock from 'highcharts/highstock';
import Chart from "../Chart";
import API from '../../../config/API';
import {getDataFilesCacheVersion} from "../../../helpers/cache";

require('highcharts-more')(Highstock);
require('highcharts/modules/exporting')(Highstock);
require('highcharts/modules/export-data.src')(Highstock);
const ReactHighcharts = require('react-highcharts/ReactHighstock').withHighcharts(Highstock);

class PrimaryDealerNetPositions extends Chart {

    componentDidMount() {
        request.get(API.getHost('data').concat(getDataFilesCacheVersion('/data-feeds/charts/MarketInsights/dealer_net_positions.csv'))).then(data => {
            const options = {
                //chart options
                chart: {
                    //set type of graph, where it renders
                    type: 'area',
                    renderTo: 'dealer_net_positions_container',
                    height: 600,
                    style: {
                        fontFamily: 'Exo'
                    }
                },
                //set title of graph
                title: {
                    text: 'Primary Dealer Net Positions',
                    style: {
                        color: '#4D759E'
                    },
                    align: 'center'
                },
                //set xAxis title
                xAxis: {
                    title: {
                        text: 'Date',
                        style: {
                            color: '#4D759E',
                            fontWeight: 'bold'
                        }
                    }
                },
                //set yAxis info
                yAxis: {
                    title: {
                        text: 'Primary Dealer Net Positions ( Millions )',
                        style: {
                            color: '#4D759E',
                            fontWeight: 'bold'
                        }
                    },
                    //make y-axis labels have , to seperate thousands places
                    labels: {
                        formatter: function () {
                            return Highcharts.numberFormat(this.value, 0, '', ',');
                        }
                    },
                    //set y-axis to the left side
                    opposite: false,
                    //set background grid line width
                    gridLineWidth: 1,
                    reversedStacks: false
                },
                //stylize the tooltip
                tooltip: {
                    pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b><br/>',
                    valuePrefix: '$',
                    //valueSuffix: ' Million',
                    //make the tooltip say "week from" rather than "day of"
                    dateTimeLabelFormats: {
                        day: "Week from %A, %b %e, %Y",
                        week: "Week from %A, %b %e, %Y"
                    }
                },
                //enable and stylize the legend
                legend: {
                    enabled: true,
                    layout: 'horizontal',
                    align: 'center',
                    borderWidth: 1,
                    borderRadius: 5,
                    itemDistance: 20,
                    reversed: false
                },
                //set the starting range. 0-5. 5="All", 4="1yr", etc
                rangeSelector: {
                    selected: 3,
                    allButtonsEnabled: true
                },
                //set general plot options
                plotOptions: {
                    area: {
                        stacking: 'normal',
                        lineWidth: 0
                    }
                },
                //disable credits
                credits: {
                    enabled: false
                },
                //make download as csv format correctly
                navigator: {
                    series: {
                        includeInCSVExport: false
                    }
                },
                //set name of chart downloads
                exporting: {
                    filename: 'MarketAxess_dlr_bond_inv',
                    //enable download icon
                    enabled: true,
                    //add image to download
                    chartOptions: {
                        chart: {
                            events: {
                                load: function () {
                                    this.renderer.image('/public/images/charts/marketaxess_logo2.gif', 90, 75, 300, 48).attr({
                                        opacity: 0.1
                                    }).add();
                                }
                            }
                        },
                        //remove scrollbar and navigator from downloaded image
                        scrollbar: {
                            enabled: false
                        },
                        navigator:{
                            enabled: false
                        }
                    },
                    //make download as csv format correctly
                    csv: {
                        dateFormat: '%Y-%m-%d'
                    }
                },
                //set graph colors
                colors: [
                    '#1D5B7F',
                    '#76b34d',
                    '#636569',
                    '#6786B8',
                    '#8244FF',
                    '#848486',
                    '#a42a47',
                    '#f8dc32',
                    '#2a84b9',
                    '#91c271',
                    '#818388',
                    '#8598c6',
                    '#cd3d60',
                    '#f6e35b',
                    '#11374c',
                    '#476c2e',
                    '#3b3d3f',
                    '#374f75',
                    '#621903',
                    '#ad9506'
                ],
                //series to be filled by data
                series: []
            };
            //names of labels in order of series. make sure they are the same as series header in data file
            const names = [
                'Pre-2013 Reporting',
                'Commercial Paper',
                'HG (All Maturities)',
                'HY (All Maturities)',
                'HG (<=13mths)',
                'HG (>13mths, <=5yrs)',
                'HG (>5yrs, <=10yrs)',
                'HG (>10yrs)',
                'HY (<=13mths)',
                'HY (>13mths, <=5yrs)',
                'HY (>5yrs, <=10yrs)',
                'HY (>10yrs)',
                'RMBS',
                'CMBS'
            ];
            //get csv file, multiply by 100 (divide by .01) and populate chart
            this.readCSV(options, data.text, 1, names);
            this.setState({options});
        });
    }

    render() {
        if (!this.state.options) return null;

        return(
            <div className="container">
                <ReactHighcharts config={this.state.options}/>
            </div>
        );
    }
}

export default PrimaryDealerNetPositions;



// WEBPACK FOOTER //
// ./frontend/components/Charts/MarketInsights/PrimaryDealerNetPositions.jsx